import React from "react";
import Title from "../../../components/Title/Title";

const FullAgenda2025page = () => {
    return (
        <div>
            <Title>Full Agenda</Title>
            <p>Below please find the schedule of the CLeaR 2025 conference:</p>

            <h5><font color="darkcyan">Day 1 (May 7, Wednesday)</font></h5>
            <table>
                <tr>
                    <b>08:45-09:15: Registration</b>
                </tr>
                <tr>
                    <b>09:15-09:30: Welcome</b>
                </tr>
                <tr>
                    <b>09:30-10:30: Keynote by <a href="https://www.cs.columbia.edu/~blei/">David Blei</a>: "Hierarchical Causal Models"</b>
                    {/* <ul>
                        <li></li>
                    </ul> */}
                </tr>
                <tr>
                    <b>10:30-11:00: Coffee break</b>
                </tr>
                <tr>
                    <b>11:00-12:15: Oral Session I</b>
                    <ul>
                        <li>Oral I.1. Algorithmic Syntactic Causal Identification</li>
                        <li>Oral I.2. The Probability of Tiered Benefit: Partial Identification with Robust and Stable Inference</li>
                        <li>Oral I.3. Stabilized Inverse Probability Weighting via Isotonic Calibration</li>
                    </ul>
                </tr>
                <tr>
                    <b>12:15-14:00: Lunch break</b>
                </tr>
                <tr>
                    <b>14:00-15:30: Poster Session I</b>
                </tr>
                <ul>
                    <li>Poster I.1. Algorithmic Syntactic Causal Identification</li>
                    <li>Poster I.2. Contagion Effect Estimation Using Proximal Embeddings</li>
                    <li>Poster I.3. Matchings, Predictions and Counterfactual Harm in Refugee Resettlement Processes</li>
                    <li>Poster I.4. Automatic Debiasing of Neural Networks via Moment Constrained Learning</li>
                    <li>Poster I.5. Non-Parametric Conditional Independence Testing for Mixed Continuous-Categorical Variables: A Novel Method and Numerical Evaluation</li>
                    <li>Poster I.6. Encode-Decoder-Based GAN for Estimating Counterfactual Outcomes Under Sequential Selection Bias and Combinatorial Explosion</li>
                    <li>Poster I.7. Interpretable Neural Causal Models with TRAM-DAGs</li>
                    <li>Poster I.8. Bounds and Sensitivity Analysis of the Causal Effect Under Outcome-Independent MNAR Confounding</li>
                    <li>Poster I.9. Disparate Effect of Missing Mediators on Transportability of Causal Effects</li>
                    <li>Poster I.10. Optimizing Multi-Scale Representations to Detect Effect Heterogeneity Using Earth Observation and Computer Vision: Applications to Two Anti-Poverty RCTs</li>
                    <li>Poster I.11. Local Interference: Removing Interference Bias in Semi-Parametric Causal Models</li>
                    <li>Poster I.12. The Probability of Tiered Benefit: Partial Identification with Robust and Stable Inference</li>
                    <li>Poster I.13. Probably Approximately Correct High Dimensional Causal Effect Estimation Given a Valid Adjustment Set</li>
                    <li>Poster I.14. Stabilized Inverse Probability Weighting via Isotonic Calibration</li>
                    <li>Poster I.15. Beyond Flatland: A Geometric Take on Matching Methods for Treatment Effect Estimation</li>
                    <li>Poster I.16. Network Causal Effect Estimation in Graphical Models of Contagion and Latent Confounding</li>
                    <li>Poster I.17. Your Assumed DAG is Wrong and Here's How to Deal with It</li>
                    <li>Poster I.18. Causal Drivers of Dynamic Networks</li>
                    <li>Poster I.19. Compositional Models for Estimating Causal Effects</li>
                    <li>Poster I.20. Causal Identification in Time Series Models</li>
                </ul>
                <tr>
                    <b>15:30-16:00: Coffee break</b>
                </tr>
                <tr>
                    <b>16:00-17:15: Oral Session II</b>
                    <ul>
                        <li>Oral II.1. Causal Bandits Without Graph Learning</li>
                        <li>Oral II.2. Combining Causal Models for More Accurate Abstractions of Neural Networks</li>
                        <li>Oral II.3. Algorithmic Causal Structure Emerging Through Compression</li>
                    </ul>
                </tr>
            </table>

            <br />
            <h5><font color="darkcyan">Day 2 (May 8, Thursday)</font></h5>
            <table>
                <tr>
                    <b>09:15-10:15: Keynote by <a href="https://researchprofiles.ku.dk/en/persons/erin-evelyn-gabriel">Erin Gabriel</a>: "Causal Inference with Latent Variables"</b>
                    {/* <ul>
                        <li></li>
                    </ul> */}
                </tr>
                <tr>
                    <b>10:15-10:45: Coffee break</b>
                </tr>
                <tr>
                    <b>10:45-12:15: Poster Session II</b>
                </tr>
                <ul>
                    <li>Poster II.1. Fair Clustering: A Causal Perspective</li>
                    <li>Poster II.2. Beyond Single-Feature Importance with ICECREAM</li>
                    <li>Poster II.3. Actual Causation and Nondeterministic Causal Models</li>
                    <li>Poster II.4. Aligning Graphical and Functional Causal Abstractions</li>
                    <li>Poster II.5. Transfer Learning in Latent Contextual Bandits with Covariate Shift Through Causal Transportability</li>
                    <li>Poster II.6. Causal Bandits Without Graph Learning</li>
                    <li>Poster II.7. Counterfactual Influence in Markov Decision Processes</li>
                    <li>Poster II.8. Omitted Labels Induce Nontransitive Paradoxes in Causality</li>
                    <li>Poster II.9. The Causal-Effect Score in Data Management</li>
                    <li>Poster II.10. Inducing Causal Structure Applied to Glucose Prediction for T1DM Patients</li>
                    <li>Poster II.11. Combining Causal Models for More Accurate Abstractions of Neural Networks</li>
                    <li>Poster II.12. Counterfactual Explanability of Black-Box Prediction Models</li>
                    <li>Poster II.13. MXMap: A Multivariate Cross Mapping Framework for Causal Discovery in Dynamical Systems</li>
                    <li>Poster II.14. Counterfactual Token Generation in Large Language Models</li>
                    <li>Poster II.15. Algorithmic Causal Structure Emerging Through Compression</li>
                    <li>Poster II.16. On Measuring Intrinsic Causal Attributions in Deep Neural Networks</li>
                    <li>Poster II.17. Relational Object-Centric Actor-Critic</li>
                    <li>Poster II.18. Extending Structural Causal Models for Autonomous Vehicles to Simplify Temporal System Construction & Enable Dynamic Interactions Between Agents</li>
                </ul>
                <tr>
                    <b>12:15-14:00: Lunch break</b>
                </tr>
                <tr>
                    <b>14:00-15:30: Oral Session III</b>
                    <ul>
                        <li>Oral III.1. Causal Reasoning in Difference Graphs</li>
                        <li>Oral III.2. An Asymmetric Independence Model for Causal Discovery on Path Spaces</li>
                        <li>Oral III.3. Scalable Causal Structure Learning via Amortized Conditional Independence Testing</li>
                    </ul>
                </tr>
                <tr>
                    <b>15:30-16:00: Coffee break</b>
                </tr>
                <tr>
                    <b>16:00-16:30: Town hall discussion</b>
                </tr>
                <tr>
                    <b>16:30-18:00: Transition to social event</b>
                </tr>
                <tr>
                    <b>18:00: Meet at <a href="https://www.aquatis.ch/en/visit-aquatis/access">Aquatis (Lausanne aquarium)</a></b>
                </tr>
                <tr>
                    <b>18:15-19:15: Aquarium visit</b>
                </tr>
                <tr>
                    <b>19:15-22:00: Buffet dinner</b>
                </tr>
            </table>

            <br />
            <h5><font color="darkcyan">Day 3 (May 9, Friday)</font></h5>
            <table>
                <tr>
                    <b>09:15-10:15: Keynote by <a href="https://www.engineering.columbia.edu/faculty-staff/directory/elias-bareinboim">Elias Bareinboim</a>: "Towards Causal Artificial Intelligence"</b>
                    {/* <ul>
                        <li></li>
                    </ul> */}
                </tr>
                <tr>
                    <b>10:15-10:45: Coffee break</b>
                </tr>
                <tr>
                    <b>10:45-12:15: Poster Session III</b>
                </tr>
                <ul>
                    <li>Poster III.1. Causal Reasoning in Difference Graphs</li>
                    <li>Poster III.2. Shapley-PC: Constraint-Based Causal Structure Learning with a Shapley Inspired Framework</li>
                    <li>Poster III.3. Robust Multi-View Co-Expression Network Inference</li>
                    <li>Poster III.4. The CausalBench Challenge: A Machine Learning Contest for Gene Network Inference from Single-Cell Perturbation Data</li>
                    <li>Poster III.5. Score Matching Through the Roof: Linear, Nonlinear, and Latent Variables Causal Discovery</li>
                    <li>Poster III.6. Exact Discovery is Polynomial for Certain Sparse Causal Bayesian Networks</li>
                    <li>Poster III.7. Cross-Validating Causal Discovery via Leave-One-Variable-Out</li>
                    <li>Poster III.8. The Interventional Bayesian Gaussian Equivalent Score for Bayesian Causal Inference with Unknown Soft Interventions</li>
                    <li>Poster III.9. The Landscape of Causal Discovery Data: Grounding Causal Discovery in Real-World Applications</li>
                    <li>Poster III.10. An Asymmetric Independence Model for Causal Discovery on Path Spaces</li>
                    <li>Poster III.11. AGM-TE: Approximate Generative Model Estimator of Transfer Entropy for Causal Discovery</li>
                    <li>Poster III.12. Controlling for Discrete Unmeasured Confounding in Nonlinear Causal Models</li>
                    <li>Poster III.13. Constraint-Based Causal Discovery with Tiered Background Knowledge and Latent Variables in Single or Overlapping Datasets</li>
                    <li>Poster III.14. Sample Complexity of Nonparametric Closeness Testing for Continuous Distributions and Its Application to Causal Discovery with Hidden Confounding</li>
                    <li>Poster III.15. Multi-Domain Causal Discovery in Bijective Causal Models</li>
                    <li>Poster III.16. Selecting Accurate Subgraphical Models from Possibly Inaccurate Graphical Models</li>
                    <li>Poster III.17. Scalable Causal Structure Learning via Amortized Conditional Independence Testing</li>
                    <li>Poster III.18. Temporal Inverse Probability Weighting for Causal Discovery in Controlled Before-After Studies: Discovering ADEs in Generics</li>
                    <li>Poster III.19. Unitless Unrestricted Markov-Consistent SCM Generation: Better Benchmark Datasets for Causal Discovery</li>
                    <li>Poster III.20. Nondeterministic Causal Models</li>
                </ul>
                <tr>
                    <b>12:15-12:30: Wrap up</b>
                </tr>
            </table>
            <br />
        </div>
    )
}

export default FullAgenda2025page;